import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/generated/IconApplicationStatusApprovalDocument.tsx
const IconApplicationStatusApprovalDocument = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 20 20",
	"aria-hidden": "true",
	"data-slot": "icon",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ jsx("path", {
		fill: "currentColor",
		d: "M15.833 18.333H4.166a2.5 2.5 0 0 1-2.5-2.5V2.5c0-.46.373-.833.833-.833h11.667c.46 0 .833.373.833.833v10h3.334v3.333a2.5 2.5 0 0 1-2.5 2.5m-.834-4.166v1.666a.833.833 0 0 0 1.667 0v-1.667zM5 5.833V7.5h6.667V5.833zm0 3.333v1.667h6.667V9.166zM5 12.5v1.666h4.167V12.5z"
	})]
});
var IconApplicationStatusApprovalDocument_default = forwardRef(IconApplicationStatusApprovalDocument);
//#endregion
export { IconApplicationStatusApprovalDocument_default as default };
